module.exports = __webpack_public_path__ + "static/media/add-circle.bccc2a63.svg";